import { render, staticRenderFns } from "./Addone.vue?vue&type=template&id=6bedca4a"
import script from "./Addone.vue?vue&type=script&lang=js"
export * from "./Addone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports